import { useNavigate } from 'react-router-dom'

import { cn } from 'src/shared/utils/cn'

import type { IconName } from './tab-button-icon'
import TabButtonIcon from './tab-button-icon'

interface TabButtonProps {
  label: string
  iconName?: IconName
  activeIconName?: IconName
  onClick?: () => void
  isActive?: boolean
  to?: string
  // if true, the label will be hidden but still take up space
  hideLabel?: boolean
  iconScale?: number
  iconClassName?: string
  labelClassName?: string
  className?: string
  // the container that shows a light white background when hovered
  hoverContainerClassName?: string
  shouldLabelBeInsideHoverContainer?: boolean
}

export default function TabButton({
  label,
  iconName,
  activeIconName,
  onClick,
  isActive,
  to,
  hideLabel,
  iconScale,
  className,
  iconClassName,
  labelClassName,
  hoverContainerClassName,
  shouldLabelBeInsideHoverContainer,
}: TabButtonProps) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    if (to) {
      navigate(to)
    }
  }

  const renderLabel = () => {
    return (
      <span
        className={cn(
          'text-sm font-semibold leading-[1] transition-all duration-300',
          hideLabel && 'opacity-0',
          labelClassName,
        )}
      >
        {label}
      </span>
    )
  }

  return (
    <button
      onClick={handleClick}
      className={cn(
        'group flex flex-col items-center gap-[2px] text-white/75 hover:text-white',
        isActive && 'text-white',
        className,
      )}
    >
      <div
        className={cn(
          'flex h-[50px] w-[50px] flex-shrink-0 items-center justify-center rounded-[10px] transition-all duration-200 group-hover:scale-110 group-hover:bg-white/15 group-active:bg-white/20',
          isActive && 'bg-white/15',
          hoverContainerClassName,
        )}
      >
        {iconName && (
          <TabButtonIcon
            name={isActive && activeIconName ? activeIconName : iconName}
            className={cn('flex-shrink-0', iconClassName, iconScale && `scale-[${iconScale}]`)}
          />
        )}
        {shouldLabelBeInsideHoverContainer && renderLabel()}
      </div>
      {!shouldLabelBeInsideHoverContainer && renderLabel()}
    </button>
  )
}
